import { ClaimedIcon } from "./icons";
import StatusWrapper from "./status-wrapper";

function Content() {
  const handleContact = () => {
    if (!window.Intercom) {
      return;
    }

    window.Intercom("show");
  };

  return (
    <p className="text-14/[1.71em] text-heather">
      This business has already been claimed.
      <br />
      <br />
      {/** biome-ignore lint/a11y/noStaticElementInteractions: its fine */}
      {/** biome-ignore lint/a11y/useKeyWithClickEvents: its fine */}
      {/** biome-ignore lint/a11y/noNoninteractiveElementInteractions: its fine */}
      <span
        className="cursor-pointer text-rose-red hover:underline"
        onClick={handleContact}
      >
        Contact us
      </span>{" "}
      to request changes.
    </p>
  );
}

export interface ClaimedProps extends React.ComponentProps<"svg"> {}

export default function Claimed(props: ClaimedProps) {
  return (
    <StatusWrapper
      content={<Content />}
      popoverProps={{
        align: "start",
        side: "top",
      }}
      title="Claimed business"
    >
      <div className="inline-flex items-center">
        <ClaimedIcon {...props} />
      </div>
    </StatusWrapper>
  );
}
